/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamConductPhase } from './oralExamConductPhase';

export type OralExamAgentControlStateResponseConductPhase = OralExamConductPhase | null;
